import styled, { css } from 'styled-components';
import { mixin } from '@wconcept/wconcept-ui-renewal/styles/index';

interface IDateTabItemProps {
  $bgColor?: string;
  $textColor?: string;
  $pointColor?: string;
  $emphasisTextColor?: string;
}

export const DateTabItem = styled.div<IDateTabItemProps>`
  .btn {
    width: 54px;
    height: 62px;
    background: #fff;
    border: 1px solid #eee;
    border-radius: 10px;
    flex-direction: column;

    .text {
      font-weight: 600;
    }

    .day-text {
      font-size: 11px;
      line-height: 130%;
      margin-bottom: 2px;
      color: #999;
    }

    .date-text {
      font-size: 15px;
      line-height: 150%;
      color: #555;
    }
  }

  &.type-small {
    .btn {
      width: auto;
      height: 34px;
      border-color: #e2e2e2;
      border-radius: 6px;
      padding: 0 10px;
      ${mixin.flex({
        align: 'center',
        justify: 'center',
        direction: 'row-reverse',
      })}
      gap: 0 2px;

      .text {
        font-weight: 500;
        font-size: 14px;
        line-height: normal;
        margin: 0;
        color: #000;
      }
    }

    &.is-today {
      .day-text {
        position: relative;
        padding-right: 6px;

        &:after {
          content: '';
          display: block;
          width: 4px;
          height: 4px;
          background: #ff4600;
          border-radius: 50%;
          position: absolute;
          top: 0;
          right: 0;
        }
      }
    }
  }

  &.type-time {
    .btn {
      width: auto;
      min-width: 74px;
      height: 54px;
      padding: 0 12px;
      border-radius: 6px;
      gap: 4px;

      .date-text {
        position: relative;
        font-size: 14px;
        line-height: 130%;
        font-weight: 600;
        letter-spacing: -0.084px;
        color: #000;
      }

      .time-text {
        font-size: 12px;
        line-height: 130%;
        font-weight: 500;
        letter-spacing: -0.072px;
        color: #999;
      }
    }

    &.is-today {
      .date-text {
        display: inline-block;
        padding-right: 6px;

        &:after {
          content: '';
          display: block;
          width: 4px;
          height: 4px;
          background: #ff4600;
          border-radius: 50%;
          position: absolute;
          top: 0;
          right: 0;
        }
      }
    }
  }

  &.bg-type-black {
    .btn {
      background: #000;
      border-color: #333;

      .day-text {
        color: #777;
      }

      .date-text {
        color: #ccc;
      }
    }

    &.type-small .day-text {
      color: #ccc;
    }

    &.active {
      .btn {
        background: #fff;
        border-color: #fff;

        .day-text,
        .date-text {
          color: #000;
        }
      }
    }
  }

  &.active {
    .btn {
      background: #000;
      border-color: #000;

      .day-text,
      .date-text {
        color: #fff;
      }
    }
  }

  ${({ $bgColor, $textColor, $pointColor, $emphasisTextColor }) =>
    $bgColor &&
    css`
      .btn {
        background: ${$bgColor};
        border-color: #e2e2e2;

        .day-text,
        .date-text {
          color: ${$textColor} !important;
        }
      }

      &.active {
        .btn {
          background: ${$pointColor};
          border-color: ${$pointColor};

          .day-text,
          .date-text {
            color: ${$emphasisTextColor} !important;
          }
        }
      }
    `}

  &.is-today.type-default .day-text {
    color: #ff6b33;
  }

  @media ${({ theme }) => theme.media.smMax} {
    .btn {
      width: ${mixin.pxToVw('54')};
      height: ${mixin.pxToVw('62')};
      border-radius: ${mixin.pxToVw('10')};

      .day-text {
        font-size: ${mixin.pxToVw('11')};
        margin-bottom: ${mixin.pxToVw('2')};
      }

      .date-text {
        font-size: ${mixin.pxToVw('15')};
      }
    }

    &.type-small {
      .btn {
        height: ${mixin.pxToVw('34')};
        border-radius: ${mixin.pxToVw('6')};
        padding: ${mixin.pxToVw('0 10')};
        gap: ${mixin.pxToVw('0 2')};

        .text {
          font-size: ${mixin.pxToVw('14')};
        }
      }

      &.is-today {
        .day-text {
          padding-right: ${mixin.pxToVw('6')};

          &:after {
            width: ${mixin.pxToVw('4')};
            height: ${mixin.pxToVw('4')};
          }
        }
      }
    }

    &.type-time {
      .btn {
        min-width: ${mixin.pxToVw('74')};
        height: ${mixin.pxToVw('54')};
        padding: ${mixin.pxToVw('0 12')};
        border-radius: ${mixin.pxToVw('6')};
        gap: ${mixin.pxToVw('4')};

        .date-text {
          font-size: ${mixin.pxToVw('14')};
        }

        .time-text {
          font-size: ${mixin.pxToVw('12')};
        }
      }

      &.is-today {
        .date-text {
          padding-right: ${mixin.pxToVw('6')};

          &:after {
            width: ${mixin.pxToVw('4')};
            height: ${mixin.pxToVw('4')};
          }
        }
      }
    }
  }

  @media ${({ theme }) => theme.media.pc} {
    .btn {
      width: 80px;
      height: 80px;
      padding: 9px 0;

      .day-text {
        font-size: 16px;
      }

      .date-text {
        font-size: 20px;
      }
    }

    &.type-small {
      .btn {
        width: 108px;
        height: 50px;
        padding: 0;
        border-radius: 10px;
        gap: 0 4px;

        .text {
          font-size: 18px;
        }
      }

      &.is-today .day-text {
        padding-right: 7px;

        &:after {
          width: 5px;
          height: 5px;
        }
      }
    }

    &.type-time {
      .btn {
        min-width: 160px;
        height: 50px;
        padding: 0 18px;
        border-radius: 10px;
        flex-direction: row;
        gap: 6px;

        .date-text {
          font-size: 18px;
          letter-spacing: -0.108px;
        }

        .time-text {
          font-size: 14px;
          letter-spacing: -0.084px;
        }
      }

      &.is-today .date-text {
        padding-right: 7px;

        &:after {
          width: 5px;
          height: 5px;
        }
      }
    }
  }
`;
